<fip-failure-during-incoming-inspection-form
  (formSubmit)="onFormSubmit($event)"
/>
